import { useTheme } from "@mui/material";
import { CarPortfolioChartItem } from "@app/pages/assetAllocation/asset-allocation-types";
import {
  CarPdfHeader,
  CarPdfHeaderCell,
  CarPdfRow,
  CarPdfTable,
  CarPdfTableProps,
  CarPdfTextCell,
} from "@app/components/PdfTable";
import { getMultiPeriodReturnComparisonExcelTable } from "@app/pages/assetAllocation/editPortfolioGroup/TableMultiPeriodReturnComparison";
import {
  ExcelDataFormat,
  excelTableFormatValue,
} from "@app/hooks/useExcelExport";
import {
  AssetClassAnalysisTabId,
  getAssetClassAnalysisSummaryTableColumns,
} from "../AssetClassAnalysisSummary";
import { CarAssetClassAnalysisItem } from "../useAssetClassSummaryStat";

interface SummaryPdfTableProps
  extends Omit<CarPdfTableProps, "children" | "collWidths"> {
  rows: CarAssetClassAnalysisItem[];
  isReal: boolean;
  pageId: AssetClassAnalysisTabId;
}

export const SummaryPdfTable = ({
  rows,
  pageId,
  isReal,
  ...props
}: SummaryPdfTableProps) => {
  const theme = useTheme();

  const columns = getAssetClassAnalysisSummaryTableColumns(pageId, isReal);

  return (
    <CarPdfTable
      colWidths={[1.5, ...columns.map(() => 1)]}
      isRounded
      isStriped
      {...props}
    >
      <CarPdfHeader paddingVertical={14} key="label">
        <CarPdfHeaderCell key="label"></CarPdfHeaderCell>
        {columns.map((i, idx) => (
          <CarPdfHeaderCell key={idx}>{i.label}</CarPdfHeaderCell>
        ))}
      </CarPdfHeader>
      {rows.map((row, rowIdx) => (
        <CarPdfRow key={rowIdx} paddingVertical={10}>
          <CarPdfTextCell
            key="label"
            style={{
              textAlign: "left",
              paddingHorizontal: 15,
            }}
          >
            {row.name}
          </CarPdfTextCell>

          {columns.map((column, valueIdx) => (
            <CarPdfTextCell
              key={valueIdx}
              style={{
                paddingHorizontal: 15,
              }}
            >
              {column.formatValue(row[column.id])}
            </CarPdfTextCell>
          ))}
        </CarPdfRow>
      ))}
    </CarPdfTable>
  );
};
